import { createSelector } from 'reselect';

const getItems = state => state.items;
const getEntities = state => state.entities;
const getCurrentDir = state => state.directoryId;
const getFilter = state => state.filter;

const makeGetVisibleItems = () => {
  return createSelector(
    getItems,
    getEntities,
    getFilter,
    state => state.sort,
    (items, entities, filter, sort) => {
      let files = items.map(id => entities[id]);
      if (filter.type) {
        files = files.filter(
          file => file.type === 'dir' || file.type === filter.type
        );
      }
      if (filter.searchText) {
        const regexp = new RegExp(filter.searchText, 'i');
        files = files.filter(file => file.name.search(regexp) > -1);
      }
      files.sort((left, right) => {
        if (left.type === 'dir' && right.type !== 'dir') {
          return -1;
        } else if (left.type !== 'dir' && right.type === 'dir') {
          return 1;
        }
        const { prop, direction } = sort;
        if (typeof left[prop] === 'string') {
          const leftProp = left[prop].toUpperCase();
          const rightProp = right[prop].toUpperCase();
          if (leftProp < rightProp) return direction === 'asc' ? -1 : 1;
          if (leftProp > rightProp) return direction === 'asc' ? 1 : -1;
          return 0;
        }
        const leftProp = left[prop];
        const rightProp = right[prop];
        if (leftProp < rightProp) return direction === 'asc' ? -1 : 1;
        if (leftProp > rightProp) return direction === 'asc' ? 1 : -1;
        return 0;
      });
      return files;
    }
  );
};

export const getVisibleItems = makeGetVisibleItems();

const makeGetTotal = () => {
  return createSelector(getItems, items => items.length);
};

export const getTotal = makeGetTotal();



// WEBPACK FOOTER //
// ./src/js/selectors/mediaLibrary.js